export default __webpack_public_path__ + "static/media/GoodMannersInARestaurant_11.47177fa3.png";